import React from 'react';

import Link from 'next/link';

import { faBars, faForwardFast, faPhone, faRobot } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import { EVENT_NAME, useMoengageEventTracker } from '../../hooks/useMoengage';

import styles from './FloatingActionButton.module.scss';

function FloatingActionButton({ footerData }) {
  const trackMoengageEvent = useMoengageEventTracker();

  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => {
          setIsOpen((prev) => !prev);
          trackMoengageEvent(EVENT_NAME.SUPPORT_CLICKED, {
            type: 'open_widget',
          });
        }}
      >
        {isOpen ? (
          <FontAwesomeIcon icon={faBars} />
        ) : (
          <div className={styles.iconsToggle}>
            <FontAwesomeIcon icon={faForwardFast} />
            <FontAwesomeIcon icon={faRobot} />
            <FontAwesomeIcon icon={faPhone} />
            <FontAwesomeIcon icon={faForwardFast} />
          </div>
        )}
      </button>

      <div className={classNames(styles.contentWrapper, { [styles.isOpen]: isOpen })}>
        <ul className={styles.itemsList}>
          <li>
            <button
              type="button"
              className={styles.listItem}
              onClick={() => {
                window.postMessage({ showContinuePurchase: 1 });
                setIsOpen(false);
                trackMoengageEvent(EVENT_NAME.SUPPORT_CLICKED, {
                  type: 'continue_purchase',
                });
              }}
            >
              <FontAwesomeIcon icon={faForwardFast} />
              <span>Continue Purchase</span>
            </button>
          </li>
          <li>
            <button
              type="button"
              className={styles.listItem}
              onClick={() => {
                window.fcWidget.open();
                setIsOpen(false);
                trackMoengageEvent(EVENT_NAME.SUPPORT_CLICKED, {
                  type: 'help_clicked',
                });
              }}
            >
              <FontAwesomeIcon icon={faRobot} />
              <span>Help</span>
            </button>
          </li>

          <li className={styles.listItemDesktop}>
            <span
              className={styles.listItem}
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText('+91-76-4000-3000');
                } catch (err) {
                  console.error('Failed to copy text: ', err);
                }

                trackMoengageEvent(EVENT_NAME.SUPPORT_CLICKED, {
                  type: 'request_callback',
                });
              }}
            >
              <FontAwesomeIcon icon={faPhone} />
              <span>+91-76-4000-3000</span>
            </span>
          </li>

          {footerData?.constantWeb && (
            <li className={styles.listItemMobile}>
              <Link
                href={`tel:${footerData?.constantWeb?.SUPPORT_PHONE_NUMBER}`}
                className={styles.listItem}
                onClick={() => {
                  trackMoengageEvent(EVENT_NAME.SUPPORT_CLICKED, {
                    type: 'request_callback',
                  });
                }}
              >
                <FontAwesomeIcon icon={faPhone} />
                <span>Connect</span>
              </Link>
            </li>
          )}

          <li>
            <Link
              href={'https://wa.me/+919649876464'}
              className={styles.listItem}
              onClick={() => {
                trackMoengageEvent(EVENT_NAME.SUPPORT_CLICKED, {
                  type: 'request_callback',
                });
              }}
            >
              <FontAwesomeIcon icon={faWhatsapp} />
              <span>WhatsApp</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default FloatingActionButton;
